<!--
 * @Date: 2022-11-01 15:18:24
 * @Author: 王溪
 * @LastEditTime: 2022-12-07 15:40:25
 * @description: 
 * @FilePath: \pcweb-share\src\App.vue
 * @LastEditors: 王溪
-->
<template>
  <div id="app" :class="{'is_pc':is_pc == true}">
    <van-loading v-show="showLoading" class="loading" type="spinner" color="#fff">{{ loadingText }}</van-loading>
  <!--页面返回不刷新-->
  <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        :key="$route.path"
      ></router-view>
    </keep-alive>
    <!--不需要缓存组件-->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
 
  </div>
</template>

<script>
import { userAgent } from '@/utils/utils'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'App',
  data(){
    return{
      is_pc: false,
    }
  },
  mounted(){
    this.is_pc = userAgent() ? false : true
    this.$store.commit('setApi_Version',window.location.pathname.includes('/share')?'v1':'v2')
  },
  computed: {
    ...mapState({
      showLoading: 'showLoading',
      loadingText: 'loadingText'
    })
  },
  methods:{

  }
}
</script>
<style rel='stylesheet/less'>
  
</style>
<style lang="less" scoped>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #666;
}
.loading {
  position: fixed;
  left: 50%;
  top: 50%;
  height: 66px;
  line-height: 66px;
  padding: 0 14px;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 32px;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

</style>



// WEBPACK FOOTER //
// src/App.vue